module.exports = __webpack_public_path__ + "img/bookmark-plus.f2ad2fe0.svg";